import React from 'react';
import { WizardCard } from './fdicChrome';

const TruckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4" aria-hidden="true">
    <path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <circle cx="7" cy="17" r="2" stroke="currentColor" strokeWidth="1.8" />
    <circle cx="17" cy="17" r="2" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

const fmtTimestamp = (d) => {
  if (!d) return '—';
  const date = new Date(d);
  return date
    .toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    })
    .toUpperCase();
};

const TimelineRow = ({ item, isLast }) => (
  <li className="relative flex gap-4 pb-6 last:pb-0">
    {!isLast && (
      <span className="absolute left-[9px] top-5 bottom-0 w-0.5 bg-[#0b2740]/25" />
    )}
    <span
      className={`relative z-10 w-5 h-5 rounded-full flex items-center justify-center shrink-0 mt-0.5 ${
        item.done ? 'bg-[#0b2740]' : 'bg-white border-2 border-gray-300'
      }`}
    >
      {item.done && <span className="w-2 h-2 rounded-full bg-white" />}
    </span>
    <div className="min-w-0">
      <div className="text-[10px] font-semibold tracking-[0.15em] uppercase text-gray-500">
        {fmtTimestamp(item.at)}
      </div>
      <div className="text-[15px] font-semibold text-[#1a2b3c] mt-1">
        {item.label}
      </div>
      {item.note && (
        <div className="text-[12px] text-gray-500 mt-0.5">{item.note}</div>
      )}
    </div>
  </li>
);

const Step5TrackingResults = ({ data, tracking, onComplete, submitting }) => {
  const timeline = (tracking?.timeline && tracking.timeline.length > 0)
    ? tracking.timeline
    : (data.timeline || []);

  const bankName =
    tracking?.account?.bankName ||
    data.bankName ||
    'NAVY FEDERAL CREDIT UNION';

  const statusLabel = (tracking?.account?.status || data.status || 'active').toUpperCase();

  return (
    <WizardCard headerIcon={<TruckIcon />} headerLabel="Tracking Results">
      <div className="px-5 py-6 flex flex-col items-center text-center">
        <div className="w-16 h-16 rounded-lg bg-[#0b2740] text-white flex items-center justify-center mb-4">
          <svg viewBox="0 0 24 24" fill="none" className="w-8 h-8" aria-hidden="true">
            <path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
            <circle cx="7" cy="17" r="2" stroke="currentColor" strokeWidth="1.8" />
            <circle cx="17" cy="17" r="2" stroke="currentColor" strokeWidth="1.8" />
          </svg>
        </div>
        <h2 className="font-serif text-[24px] text-[#1a2b3c]">Live Case Tracking</h2>
        <p className="text-[13px] text-gray-500 mt-2">
          Enter your Tracking ID to view real-time progress.
        </p>
      </div>

      <div className="px-5">
        <div className="text-[11px] font-semibold tracking-[0.15em] uppercase text-gray-500">
          Status:
        </div>
        <span className="mt-2 inline-block bg-[#dff3e4] text-[#1f5c3a] text-[12px] font-semibold tracking-[0.15em] px-3 py-1.5 rounded-full">
          {statusLabel}
        </span>
      </div>

      <div className="px-5 mt-5">
        <div className="bg-[#0b2740] text-white text-[12px] font-semibold tracking-[0.15em] uppercase text-center py-3 rounded-md">
          {bankName}
        </div>
      </div>

      <ol className="px-5 mt-5">
        {timeline.map((item, idx) => (
          <TimelineRow key={idx} item={item} isLast={idx === timeline.length - 1} />
        ))}

        {timeline.length === 0 && (
          <li className="text-[13px] text-gray-500 italic py-4">
            No timeline entries yet.
          </li>
        )}
      </ol>

      <div className="px-5 pb-5">
        <div className="bg-gray-50 border border-gray-100 rounded-lg p-4">
          <div className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center mb-3">
            <span className="text-[10px] font-black text-[#0b2740]">FDIC</span>
          </div>
          <div className="text-[14px] font-bold text-[#1a2b3c] uppercase">
            {bankName} Bank (FDIC)
          </div>
          <p className="mt-2 text-[13px] leading-6 text-gray-600">
            Your case is currently under formal review and is being handled by Mr. FDIC Support.
            For your reference, your case number is {data.caseId}. Please coordinate directly
            with your assigned agent for any updates, and use this reference number when
            tracking the progress of your case. Should you need any further assistance, feel
            free to reach out.
          </p>
        </div>
      </div>

      <div className="p-5">
        <button
          onClick={onComplete}
          disabled={submitting}
          className="w-full bg-[#22a06b] hover:bg-[#1f8f60] disabled:opacity-60 text-white text-[13px] font-semibold tracking-[0.15em] uppercase py-4 rounded-md"
        >
          {submitting ? 'Finalizing…' : 'Check Insured Account'}
        </button>
      </div>
    </WizardCard>
  );
};

export default Step5TrackingResults;